import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import Button from './Button'

const NotFoundPage = () => {
  return (
    <Container>
      <Box>
        <Title>404</Title>
        <Message>Oops! The page you are looking for does not exist.</Message>
        <Button
          text="Go to Home"
          color="black"
          text_transform="capitalize"
          href="/"
        />
      </Box>
    </Container>
  )
}

const Container = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  text-align: center;
`

const Title = styled(Typography)`
  font-size: 5rem;
  font-weight: bold;
  color: ${props => props.theme.colors.black};
`

const Message = styled(Typography)`
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 1rem;
`

export default NotFoundPage
